import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';

export default function Navbar({ onToggleDarkMode, isLoggedIn, setIsLoggedIn }) {
  const [showSettings, setShowSettings] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && !isLoggedIn) {
      setIsLoggedIn(true); // sync just in case on hard reload
    }
  }, [isLoggedIn, setIsLoggedIn]);

  const handleSignOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    localStorage.removeItem("isLoggedIn");
    setIsLoggedIn(false); // ✅ instantly update navbar
    navigate("/login");
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo">Smart ID</div>
      <ul className="navbar-links">
        <li><Link to="/">Home</Link></li>

        {isLoggedIn ? (
          <li><Link to="/Profile">Profile</Link></li>
        ) : (
          <li><Link to="/login">Login</Link></li>
        )}

        <li>
          <button
            onClick={() => setShowSettings(!showSettings)}
            className="settings-button"
          >
            Settings
          </button>
          {showSettings && (
            <div className="dropdown-menu">
              <button onClick={onToggleDarkMode}>Toggle Dark Mode</button>
            </div>
          )}
        </li>

        <li>
          {isLoggedIn ? (
            <button className="get-started sign-out-button" onClick={handleSignOut}>
              Sign Out
            </button>
          ) : (
            <Link to="/SignUp" className="get-started-container">
              <button type="button" className="get-started">
                Get Started
              </button>
            </Link>
          )}
        </li>
      </ul>
    </nav>
  );
}
